import { useCallback, useEffect } from "react";

import { ResponseHandler } from "@king-ict/eupisi-ui/components";
import { useKeycloak } from "@king-ict/eupisi-ui/hooks";

import { useAppDispatch } from "../app/store";
import Layout from "../features/Layout/Layout";
import { LoginMenu } from "../features/Login";
import { webUserPortalAplicationUrl } from "../routes/routes";
import Routing from "../routes/Routing";
import { fetchCurrentRole } from "../slices/applicationSlice";
import {
  getCurrentImportantDate,
  getCurrent as getCurrentPedagogicalYear,
  getRegularTerm,
} from "../slices/pedagogicalYearSlice";

export default function App() {
  const { keycloak } = useKeycloak();
  const dispatch = useAppDispatch();

  useEffect(() => {
    if (keycloak.authenticated) {
      (async () => {
        await dispatch(fetchCurrentRole());
        dispatch(getCurrentPedagogicalYear());
        dispatch(getCurrentImportantDate());
        dispatch(getRegularTerm());
      })();
    }
  }, [keycloak.authenticated, dispatch]);

  const setImpairedStyle = useCallback(() => {
    document.documentElement.classList.add("theme-vision-impaired");
    document.documentElement.classList.remove("theme-default");
  }, []);

  const removeImpairedStyle = useCallback(() => {
    document.documentElement.classList.add("theme-default");
    document.documentElement.classList.remove("theme-vision-impaired");
  }, []);

  if (!keycloak.authenticated && process.env.REACT_APP_ENV === "QA") {
    return (
      <div>
        <LoginMenu />
        {/* <Footer></Footer> */}
      </div>
    );
  }

  if (!keycloak.authenticated) {
    window.location.href = `${webUserPortalAplicationUrl}`;
  }

  return (
    <>
      <Layout
        setImpairedStyle={setImpairedStyle}
        removeImpairedStyle={removeImpairedStyle}
      >
        <ResponseHandler />
        <Routing />
      </Layout>
    </>
  );
}
